import { render, staticRenderFns } from "./join.vue?vue&type=template&id=daebc5a6"
import script from "./join.vue?vue&type=script&lang=ts"
export * from "./join.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports